var roles = {
  ACCOUNT_MANAGER: 'Account Manager',
  ADMINISTRATOR: 'Administrator',
  DATA_ADMINISTRATOR: 'Data Administrator',
  DELIVERY_DRIVER: 'Delivery Driver',
  EXTERNAL_ACCOUNTANT: 'External Accountant',
  LEAD_ACCOUNT_MANAGER: 'Lead Account Manager',
  OPERATIONS: 'Operations'
};

/**
 * Given `role`, determine if it is an admin role. This is used to give users special access to perform actions that may be time, or otherwise, constrained for other users.
 * @param {string} role - The role to check.
 * @returns {boolean} Whether the given role is an admin role.
 */
function isAdmin(role) {
  return [roles.ADMINISTRATOR, roles.DATA_ADMINISTRATOR].includes(role);
}

export { isAdmin, roles };
